import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';
import DexConfigForm from './components/DexConfigForm';

/**
 * DEX配置页面
 * 用于管理DEX服务的配置信息，包括：
 * - RPC配置
 * - DEX配置
 * - 钱包配置
 */
const DexConfigPage: React.FC = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ my: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          DEX 配置管理
        </Typography>
        <Typography variant="body1"  paragraph>
          配置和管理不同链上的DEX服务参数，包括RPC节点、DEX信息和钱包管理。
        </Typography>
        
        <Paper sx={{ p: 3, mt: 3 }}>
          <DexConfigForm />
        </Paper>
      </Box>
    </Container>
  );
};

export default DexConfigPage;
